import React, { useState } from 'react'; // Add useState for loading state
import { useDispatch } from 'react-redux';
import { deleteSong, getAllWatermarkSongs, getAllWithouWatermarkSongs } from '../../redux/reduxSlices/audioUploadSlice';
import toast from 'react-hot-toast';

const DeleteConfirmationPopup = ({
    isOpen,
    onClose,
    deleteOrder
}) => {
    const dispatch = useDispatch();
    const [isDeleting, setIsDeleting] = useState(false); // Loading state

    if (!isOpen) return null;

    const handleDeleteOrder = async () => {
        setIsDeleting(true);
        const payload = {
            "order_id": deleteOrder.order_id,
            "song_id": deleteOrder.song_id,
            "collection_type": deleteOrder.collection_type
        };

        try {
            const response = await dispatch(deleteSong(payload));
            if (response.payload?.success) {
                if (deleteOrder.collection_type == "with_watermark") {
                    await dispatch(getAllWatermarkSongs());
                } else {
                    await dispatch(getAllWithouWatermarkSongs())
                }
                onClose();
                toast.success("Audio deleted successfully!");
                // You might want to add a success toast here
            }
        } catch (error) {
            console.log("error", error);
            // You might want to add an error toast here
        } finally {

            setIsDeleting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-6">
                {/* Header */}
                <div className="text-center mb-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">
                        Are you sure you want to delete?
                    </h3>
                    <p className="text-sm text-gray-600">
                        This action cannot be undone.
                    </p>
                </div>

                {/* Buttons */}
                <div className="flex justify-center gap-4">
                    <button
                        onClick={onClose}
                        disabled={isDeleting}
                        className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium disabled:opacity-50"
                    >
                        No
                    </button>
                    <button
                        onClick={handleDeleteOrder}
                        disabled={isDeleting}
                        className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200 font-medium disabled:opacity-50 flex items-center gap-2"
                    >
                        {isDeleting ? (
                            <>
                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                Deleting...
                            </>
                        ) : (
                            'Yes'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationPopup;